import { Commit } from "vuex";
import * as types from "@/store/auth/types";
import {
	checkAuthAxios,
	checkRegisteredAxios,
	loginGenerateConfirmationCodeAxios,
	logoutAxios,
} from "@/store/auth/services";

/**
 * Регистрация
 * @param commit
 * @param payload
 */
export async function checkAuthAction({
	commit,
}: {
	commit: Commit;
}): Promise<void> {
	try {
		const { data } = await checkAuthAxios();

		commit(types.CHECK_AUTH, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Проверяем, зарегистрирован номер или нет.
 * @param commit
 * @param payload
 */
export async function checkRegisteredAction(
	{ commit }: { commit: Commit },
	payload: {
		phone: string;
	}
): Promise<void> {
	try {
		const { data } = await checkRegisteredAxios(payload);

		commit(types.CHECK_REGISTERED, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Генерация проверочного кода
 * @param commit
 * @param payload
 */
export async function loginGenerateConfirmationCodeAction(
	{ commit }: { commit: Commit },
	payload: {
		phone: string;
	}
): Promise<void> {
	try {
		const { data } = await loginGenerateConfirmationCodeAxios(payload);

		commit(types.LOGIN_CONFIRMATION_CODE, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Выход из системы
 * @param commit
 */
export async function logoutAction({
	commit,
}: {
	commit: Commit;
}): Promise<void> {
	try {
		const { data } = await logoutAxios();

		commit(types.LOGOUT, data);
	} catch (e) {
		console.log(e);
	}
}
